(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
	class BlogLoadMore extends HTMLElement {
		constructor() {
			super();
			this.button = this.querySelector('.js-blog-load-more');
			if (this.button) this.button.addEventListener('click', this.loadMore.bind(this));
		}

		loadMore() {
			const button = this.button;
			const list = this.querySelector('.blog__posts');

			button.setAttribute('disabled', '');
			button.classList.add('loading');

			fetch(button.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const fetched = html.querySelector('blog-load-more');
					const newItems = fetched ? fetched.querySelectorAll('.blog__posts .blog__post') : [];
					const newButton = fetched ? fetched.querySelector('.js-blog-load-more') : null;

					newItems.forEach((item) => list.appendChild(item));

					if (newButton) {
						button.dataset.url = newButton.dataset.url;
						button.removeAttribute('disabled');
						button.classList.remove('loading');
					} else {
						button.closest('.blog__load-more-wrapper').remove();
					}
				})
				.catch((error) => {
					console.error(error);
					button.removeAttribute('disabled');
					button.classList.remove('loading');
				});
		}
	}

	customElements.define('blog-load-more', BlogLoadMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

$(document).ready(function () {

	if ($('.product-section') && $('.product-section').length > 0) {


		// 1st carousel, main
		$('.product__media-list').flickity({
			pageDots: false,
			prevNextButtons: false,
			adaptiveHeight: true,
			wrapAround: true,
			on: {
				select: function( index ) {

					let slides = $( ".product__media-list .product__media-item");

					var iframe = $(slides[index]).find('iframe');

					var allIframes = $('.product__media-list').find('iframe');
					var video = $(slides[index]).find('video');
					var allVideos = $('.product__media-list').find('video');

					if (video && video.length > 0) {
						video.get(0).play();
					} else if (allVideos && allVideos.length > 0) {
						allVideos.get(0).pause();
					}

					if (iframe && iframe.length > 0) {
						iframe[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "playVideo"}), '*');
					} else if (allIframes && allIframes.length > 0) {
						allIframes[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "pauseVideo"}), '*');
					} else {
						return false;
					}
				}
			}
		});

		$('.product__media-list-wrapper-outer-arrow_prev').on( 'click', function() {
			$('.product__media-list').flickity('previous');
		});
		$('.product__media-list-wrapper-outer-arrow_next').on( 'click', function() {
			$('.product__media-list').flickity('next');
		});


		$('.product__media-sublist').flickity({
			asNavFor: '.product__media-list',
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			cellAlign: 'left'
		});
	}
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
